import React, { useState, useEffect } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import BuildingActions from "../../Actions/BuildingActions";
import commonUtils from "../../helpers/commonUtils";
import AppConstants from "../../Constants/AppConstants";

export default function AddBuilding(props) {
  const { selectedPlant, plantList, buildingDetails, handlePopOverModelClose } =
    props;
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [plantId, setPlantId] = useState("");
  const [buildingID, setBuildingID] = useState(AppConstants.DEFAULT_GUID);
  const [addbuilding, setBuilding] = useState("");

  useEffect(() => {
    setPlantId(selectedPlant);
  }, [props]);

  useEffect(() => {
    if (buildingDetails !== "") {
      setBuildingID(buildingDetails.id);
      setBuilding(buildingDetails.bau);

      commonUtils.setIsEdit(true);
    }
  }, [buildingDetails]);

  const buildingAdd = (e) => {
    e.preventDefault();
    const buil = {
      ID:
        buildingID === AppConstants.DEFAULT_GUID
          ? AppConstants.DEFAULT_GUID
          : buildingID,
      WerkID: plantId,
      Bau: addbuilding.trim(),
    };
    setGlobalSpinner(true);
    BuildingActions.addOrUpdateBuildingByPlantId(buil);
  };

  function handlePopOverClose() {
    setBuilding("");
    setBuildingID(AppConstants.DEFAULT_GUID);
    handlePopOverModelClose();
  }

  return (
    <div
      className="modal fade"
      id="addBuildingpopOver"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addBuildingpopOver"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addBuildingTitle">
              {buildingDetails
                ? localization.editBuilding
                : localization.addBuilding}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addBuildingModalClose"
              onClick={handlePopOverClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form id="addBuildingAdd" autoComplete="off" onSubmit={buildingAdd}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="plantList">{localization.plant}</label>
                <select
                  className="form-control"
                  id="plantList"
                  name="plantList"
                  required
                  disabled={buildingDetails !== ""}
                  value={plantId}
                  onChange={(e) => {
                    setPlantId(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    {localization.selectPlant}
                  </option>
                  {plantList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {`${row.bezeichnung} (${row.plantID})`}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="costCenter">
                  {localization.buildingName}
                </label>
                <input
                  type="text"
                  id="buildingName"
                  name="buildingName"
                  className="form-control"
                  required
                  placeholder={localization.buildingName}
                  value={addbuilding}
                  onChange={(e) => {
                    e.preventDefault();
                    if (addbuilding !== "") {
                      setBuilding(e.target.value);
                    } else {
                      setBuilding(e.target.value.trim());
                    }
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
